import React from 'react';
import { useSelector } from 'react-redux';

import { isPlatformModernMobileApp } from '../../platform/utils/platformDetailsUtils';
import { getThemeIsDarkMode } from '../../user/account/accountModal/interface/themeSettings/themeSelector';

import { PlatformDetails } from '../../../common/platform/platformTypes';

import './QuickNotesDownloadMobileAppPlaceholder.scss';

const GET_APP_DOWNLOAD_LINK = 'https://milanote.com/download-mobile-app';

type Props = {
    platformDetails: PlatformDetails;
};

const QuickNotesDownloadMobileAppPlaceholder = ({ platformDetails }: Props): React.ReactElement => {
    const isDarkMode = useSelector(getThemeIsDarkMode);

    const imageUri = isDarkMode
        ? require('../header/workspaceToolsHeader/quickNotes/popup/images/quick-notes-empty-phone-dark.png')
        : require('../header/workspaceToolsHeader/quickNotes/popup/images/quick-notes-empty-phone-light.png');

    return (
        <div className="QuickNotesDownloadMobileAppPlaceholder">
            <div className="phone-image">
                <img src={imageUri} height={470 / 2} draggable={false} />
            </div>
            <div className="get-app-cta">
                <div className="title">Get the Milanote mobile app</div>

                {!isPlatformModernMobileApp(platformDetails) && (
                    <div className="description">Available on iOS & Android</div>
                )}

                <a href={GET_APP_DOWNLOAD_LINK} target="_blank" rel="noopener noreferrer" className="qr-code">
                    <img
                        src={require('../header/workspaceToolsHeader/quickNotes/popup/images/quick-notes-empty-qr-code.png')}
                        width={80}
                        height={80}
                        draggable={false}
                    />
                </a>
            </div>
        </div>
    );
};

export default QuickNotesDownloadMobileAppPlaceholder;
